import { ISysOptionsDTO } from "../../../../../../libs/coreapi-dto/service/sysOptions"

export interface ISourceGoodsGroupEditModalProps {
    data: ISysOptionsDTO
    setData: (value: ISysOptionsDTO) => void
    initForGoodsGroup?: ISysOptionsDTO
    lockFromPermission?: boolean
    isEnabled?: boolean
    goodsGroupError?: string
}

export enum FieldsSourceGoodsGroup {
    ExcludeGroup = "ExcludeGroup",
    Enabled = 'Enabled'
}